import * as matchingTypes from './matchingTypes'


const MatchingDay = {
    processing: false,
    rows: [],
    pageSize: 10,
    pageNumber: 1,
    totalItems: 0,
    totalPages: 0,
    updatedAt: new Date(),
  }

  export const MatchingDayReducer = (state = MatchingDay , action) => {

    const  { type , payload} = action

    switch (type) {
      case matchingTypes.RESET_MATCHING_DAY:
        return MatchingDay;
      case matchingTypes.SET_PROCESSING_MATCHING_DAY:
        return { ...state, processing: true };
      case matchingTypes.STOP_PROCESSING_MATCHING_DAY:
        return { ...state, processing: false };
      case matchingTypes.SEARCH_MATCHING_DAY:
        
        return payload
          ? {
              ...state,
              rows: [...payload.returnResult],
               totalItems: payload.totalItems,
              totalPages: payload.totalPages,
              pageNumber: payload.pageNumber,
              pageSize: payload.pageSize, 
              updatedAt: new Date(),
              processing: false,
            }
          : { ...state, processing: false };
      
      default:
        return state;
    }
  }




  const matchingRules = {
    Rules:[],
    messageTypes:[],
    orginalMessagePart1:"",
    orginalMessagePart2:"",
    fieldsP1Element:[],
    fieldsP2Element:[],
    fieldsP1:[],
    fieldsP2:[],
    currentRule:{},
    loadAllRules:true
  }


  export const MatchingRulesReducer = (state = matchingRules , action) => {
    const  { type , payload} = action
    switch (type) {
case matchingTypes.SET_PROCESSING_MATCHING_RULE :
return {
  ...state,
  loadAllRules:true
}
case matchingTypes.STOP_PROCESSING_MATCHING_RULE :
return {
  ...state,
  loadAllRules:false
}
case "CURRENT_RULE":{
  

  let currentRuleAdd = {
    id:"",
      ruleName: "",
      messageId1: null,
      way1: "",
      messageId2: null,
      way2: "",
      matchingRuleFields: [
          {
              filedId1: null,
              elementId1: null,
              fieldId2: null,
              elementId2: null,
              mandatory: null,
              operator:''
          },
         
      ]
  
  }
  let currentRule = state.Rules.filter((rule) =>rule.id == payload)[0]
/*   let matchingRuleFields = currentRule.matchingRuleFields.slice()
  matchingRuleFields.map((item) => ({
    filedId1:state.fieldsP1.filter((field) => field.fieldId === item.filedId1)[0],
    filedId2:state.fieldsP2.filter((field) => field.fieldId === item.filedId1)[0],
    ...item
  }))
  console.log(matchingRuleFields) */
  currentRule = {
    ...currentRule,
    messageId1:state?.messageTypes.filter((mt) => mt.messageTypeId === currentRule?.messageId1)[0],
    messageId2:state?.messageTypes.filter((mt)=> mt.messageTypeId === currentRule?.messageId2)[0],
  }
  return {
    ...state,
    currentRule:payload === "add-rule" ? currentRuleAdd : currentRule
  }
}

      case "RESET_RULE": {
        
        return {
          ...state,
          orginalMessagePart1:'',
          orginalMessagePart2:'',
          fieldsP1:[],
    fieldsP2:[],
    fieldsP1Element:[],
    fieldsP2Element:[],
          
        }
      }
case matchingTypes.GET_RULES: {
  return {
    ...state,
    Rules:payload,
    loadAllRules:false
  }
}

      case matchingTypes.GET_ELEMENTS:
        return{
...state,
fieldsP1Element:payload.partNumber === "PartOne" ? payload.data : state.fieldsP1Element,
fieldsP2Element:payload.partNumber === "PartTwo" ? payload.data : state.fieldsP2Element
        }
case matchingTypes.GET_FIELDS:

  
  return{
    ...state,
    fieldsP1:payload.partNumber === "PartOne" ? payload.data.messageFields : state.fieldsP1,
    fieldsP2:payload.partNumber === "PartTwo" ? payload.data.messageFields : state.fieldsP2,
    orginalMessagePart1:payload.partNumber === "PartOne" ? payload.data.messageSample : state.orginalMessagePart1,
    orginalMessagePart2:payload.partNumber === "PartTwo" ? payload.data.messageSample : state.orginalMessagePart2,
  }

     case matchingTypes.GET_MESSAGETYPE:
      return {
        ...state,
      
        messageTypes:payload.messagesList
      }

      case matchingTypes.RESET_MATCHING_RULES:
        return matchingRules
      
      default:
        return state;
    }

  }